export const toNumberOrZero = (value?: string | null) => {
  const n = value == null ? 0 : Number(value);
  return Number.isFinite(n) ? n : 0;
}
